//hook to check if the user is on the redirection journey

import ROUTE from "@app/navigationApp/routes";
import { useAppSelector } from "@app/store/hooks";
import { getParameters } from "@app/utils";
import { Platform } from "react-native";

export const preHalfJourneyRoutes = [ROUTE.VERIFY_EMAIL, ROUTE.MF_FETCH_PORTFOLIO, ROUTE.MF_PLEDGE_PORTFOLIO, ROUTE.SET_CREDIT_LIMIT, ROUTE.CHECKING_LIMIT, ROUTE.KYC_PAN_VERIFICATION]


const useIsRedirectionJourney = () => {
    const platform = useAppSelector(state => state?.platformParams.platform);
    const currentStepId = useAppSelector(state => state?.auth?.userDetails?.linkedApplications[0]?.currentStepId);
    const newUrl = Platform.OS === 'web' ? window.location.href : '';
    const newParams = Platform.OS === 'web' ? getParameters(newUrl) : {};
    const utmSource = newParams?.utm_source;



    const isRedirectionJourney  = platform === 'FLIPKART' || platform === 'PHONEPE' || platform === 'BHARAT_PE' || platform === 'BHARAT_PE_2';
    const isInPreHalfJourney = preHalfJourneyRoutes.includes(currentStepId);

    const isFullRedirectionJourney = platform === 'PHONEPE' && utmSource === 'Phonepe_fj';



    return {isHalfRedirectionJourney: isRedirectionJourney && !isInPreHalfJourney && !isFullRedirectionJourney, isFullRedirectionJourney};
}

export default useIsRedirectionJourney;